import React from "react";

const AboutUs = () => {
  return (
    <div style={{ padding: "16px" }}>
      <h2>A project by SK Land Pro</h2>
      <p>
        A leading Real estate company with an experience of 30 Years . At SK
        Land Pro, we empower individuals and businesses to make smart real
        estate investments in commercial, residential, industrial and
        hospitality sectors.
      </p>
      <video
        src="/radianceHomes.mp4"
        // autoPlay
        loop
        style={{ width: "100%", height: "100%", margin: "12px 0px" }}
        poster="/radianceThumbnail.png"
        controls
      ></video>
      {/* <h2>Document Availability</h2> */}
      {/* <p style={{fontStyle:'italic'}}>For verification purposes, all legal and approval documents, 
        including the EC and Compliance, are available upon request. 
      <a onClick={()=>window.open("tel:+91 98828-98829")}>Click here to Call us</a> or <a onClick={()=>window.open("https://wa.me/7717302292?text=Hi, I would like to know more about the legal and approval documents (EC and Compliance). Please provide further details.", "_blank")}>Chat with us on WhatsApp.</a></p> */}


    </div>
  );
};

export default AboutUs;
